import { Button, Col, Input, message, Row, Typography } from "antd";
import axios from "axios";
import { useStudentSearch } from "hooks/useStudentSearch";
import React, { useCallback, useMemo } from "react";

const { Title, Paragraph } = Typography;

interface Props {
  eventId: number;
  alreadyRegisteredStudentIds: number[];
  onRegistration: (studentId: number) => void;
}

const ManualRegistration: React.FC<Props> = ({ eventId, alreadyRegisteredStudentIds, onRegistration }) => {
  const handleRegister = useCallback(
    (studentId: number) => {
      axios
        .post(`/events/${eventId}/admin_register/`, {
          student: studentId,
        })
        .then(() => {
          onRegistration(studentId);
          message.success("Student registrert på arrangementet");
        })
        .catch(() => {
          message.error("Noe gikk galt ved registrering av student");
        });
    },
    [eventId, onRegistration]
  );
  const { students, handleStudentSearch, loadingStudents } = useStudentSearch();
  const studentsNotYetRegistered = useMemo(() => {
    return students?.filter(student => !alreadyRegisteredStudentIds.includes(student.id));
  }, [students, alreadyRegisteredStudentIds]);
  return (
    <Col style={{ paddingTop: "32px" }}>
      <Row>
        <Title level={5} style={{ fontWeight: "normal", fontSize: "0.9rem" }}>
          Meld på studenter manuelt
        </Title>
      </Row>
      <Row>
        <Input placeholder="Søk etter studenter" onChange={e => handleStudentSearch(e.target.value)} />
      </Row>
      <Row>
        {loadingStudents && <Paragraph>Loading...</Paragraph>}
        {studentsNotYetRegistered?.length === 0 && <Paragraph>Ingen studenter funnet</Paragraph>}
        {studentsNotYetRegistered && studentsNotYetRegistered.length > 0 && (
          <Col span={24}>
            {studentsNotYetRegistered.map(student => (
              <Row key={student.id} style={{ paddingTop: "6px" }}>
                <Col span={12}>
                  {student.first_name} {student.last_name}
                </Col>
                <Col span={6}>{student.username}</Col>
                <Col span={6} style={{ textAlign: "end" }}>
                  <Button onClick={() => handleRegister(student.id)}>Registrer</Button>
                </Col>
              </Row>
            ))}
          </Col>
        )}
      </Row>
    </Col>
  );
};

export default ManualRegistration;
